export default "__VITE_ASSET__C0r3R$hE__"